import { render, staticRenderFns } from "./ConsultationBooking.vue?vue&type=template&id=10ee378d&scoped=true&"
import script from "./ConsultationBooking.vue?vue&type=script&lang=js&"
export * from "./ConsultationBooking.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationBooking.vue?vue&type=style&index=0&id=10ee378d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee378d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VTextarea})
